export const formatedPeriode = (period: string) => {
  if (period?.length !== 6) return period;
  const year = period?.substring(0, 4);
  const month = period?.substring(4, 6);

  return `${month}/${year}`;
};